module.exports = __webpack_public_path__ + "static/cecile-8917def2c9230cbeb88f5f8d90b9754c.jpg";